import { Button, Table, Popconfirm, message } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import { apiUrl } from '../../config'
import MalzemeKoduModalFront from '../ModalComponent/ConstraintModal/MalzemeKoduModalFront'
import { CopyOutlined } from '@ant-design/icons'

const MalzemeKoduFront = () => {
    const { t } = useTranslation();

    const [allData, setAllData] = useState([])
    const [modifiedData, setModifiedData] = useState([])
    const [modalOpen, setModalOpen] = useState(false)
    const [selectedRow, setSelectedRow] = useState([])
    const [refreshPage, setRefreshPage] = useState(false)
    const [rule, setRule] = useState("")
    const [getColor, setGetColor] = useState([])
    const [frontBodyMaterialType, setFrontBodyMaterialType] = useState([])
    const username = process.env.REACT_APP_USERNAME;
    const password = process.env.REACT_APP_SECRET_KEY;

    const getData = async () => {
        await axios.get(`${apiUrl}${window.location.pathname === "/simulasyon" ? "/beta" : ""}/getFrontBodyMaterial/all`, {
            auth: {
                username: username,
                password: password
            }
        })
            .then(res => setAllData(res.data))
            .catch(err => console.log(err))
    }

    useEffect(() => {
        getData()
    }, [refreshPage])


    useEffect(() => {
        const dataList = allData?.map((item, index) => ({
            key: index + 1,
            malzeme_kodu: item?.malzeme_kodu,
            tanim: item?.tanim,
            min_inventory_periodically: item?.min_inventory_periodically,
            put_inventory_before_demand: item?.put_inventory_before_demand,
            production_rate_according_demand: item?.production_rate_according_demand,
            par_obj_func_stop_exceeding_demand: item?.par_obj_func_stop_exceeding_demand,
            front_body_color: item?.front_body_color.description,
            front_body_material_type: item?.front_body_material_type.description,
            front_body_colorid: item?.front_body_color.id,
            front_body_material_typeid: item?.front_body_material_type.id,
            is_service: item?.is_service,
            id: item?.id

        }));

        setModifiedData([...dataList]);
    }, [allData]);

    const handleClick = (row) => {
        setSelectedRow(row)
        setModalOpen(true)
        setRule("changeOrder")
        axios.get(`${apiUrl}${window.location.pathname === "/simulasyon" ? "/beta" : ""}/getColor/all`, {
            auth: {
                username: username,
                password: password
            }
        })
            .then(res => setGetColor(res.data))
            .catch(err => console.log(err))

        axios.get(`${apiUrl}${window.location.pathname === "/simulasyon" ? "/beta" : ""}/getFrontBodyMaterialType/all`, {
            auth: {
                username: username,
                password: password
            }
        })
            .then(res => setFrontBodyMaterialType(res.data))
            .catch(err => console.log(err))
    }

    const handleDelete = (row) => {
        axios.delete(`${apiUrl}${window.location.pathname === "/simulasyon" ? "/beta" : ""}/deleteFrontBodyMaterial/${row.id}`, {
            headers: {
                Authorization: `Basic ${btoa(`${username}:${password}`)}`
            }
        })
            .then(res => {
                setRefreshPage(!refreshPage);
            })
            .catch(err => {
                console.error("Silme işlemi sırasında hata oluştu:", err);
            });
    };

    const handleCopy = async (row) => {
        const copiedData = {
            malzeme_kodu: row.malzeme_kodu + "00",
            tanim: row.tanim + "_copy",
            min_inventory_periodically: row.min_inventory_periodically,
            put_inventory_before_demand: row.put_inventory_before_demand,
            production_rate_according_demand: row.production_rate_according_demand,
            par_obj_func_stop_exceeding_demand: row.par_obj_func_stop_exceeding_demand,
            front_body_color: row.front_body_colorid,
            front_body_material_type: row.front_body_material_typeid,
            is_service: row.is_service
        };

        try {
            await axios.post(
                `${apiUrl}${window.location.pathname === "/simulasyon" ? "/beta" : ""}/addFrontBodyMaterial`,
                copiedData,
                {
                    headers: {
                        Authorization: `Basic ${btoa(`${username}:${password}`)}`
                    }
                }
            );
            message.success(t("constraints.copySuccess"));
            setRefreshPage(!refreshPage);
        } catch (err) {
            console.error(err);
            message.error(t("constraints.copyError"));
        }
    };

    const columns = [
        {
            title: "",
            key: "copy",
            align: "center",
            width: 60,
            fixed: "left",
            render: (_, row) => (
                <Button
                    icon={<CopyOutlined />}
                    onClick={() => handleCopy(row)}
                    className='flex justify-center items-center border-none'
                />
            )
        },
        {
            title: t("constraints.materialCode"),
            dataIndex: "malzeme_kodu",
            key: "malzeme_kodu",
            align: "center",
            width: 120,
            fixed: "left"
        },
        {
            title: t("constraints.description"),
            dataIndex: "tanim",
            key: "tanim",
            align: "center",
            width: 120,
            fixed: "left"
        },
        {
            title: t("constraints.minInventoryPeriodically"),
            dataIndex: "min_inventory_periodically",
            key: "min_inventory_periodically",
            width: 150,
            align: "center",

        },

        {
            title: t("constraints.putInventoryBeforeDemand"),
            dataIndex: "put_inventory_before_demand",
            key: "put_inventory_before_demand",
            align: "center",
            width: 150,
        },

        {
            title: t("constraints.productionRateAccordingDemand"),
            dataIndex: "production_rate_according_demand",
            key: "production_rate_according_demand",
            align: "center",
            width: 180,
        },
        {
            title: t("constraints.parObjFuncStopExceedingDemand"),
            dataIndex: "par_obj_func_stop_exceeding_demand",
            key: "par_obj_func_stop_exceeding_demand",
            align: "center",
            width: 200,

        },
        {
            title: t("constraints.frontBodyColor"),
            dataIndex: "front_body_color",
            key: "front_body_color",
            align: "center",
            width: 150,
        },
        {
            title: t("constraints.frontBodyType"),
            dataIndex: "front_body_material_type",
            key: "front_body_material_type",
            align: "center",
            width: 150,
        },
        {
            title: t("constraints.isService"),
            dataIndex: "is_service",
            key: "is_service",
            align: "center",
            width: 150,
            render: (text, record) => (
                <span>{record.is_service ? t("constraints.yes") : t("constraints.no")}</span>
            ),
        },
        {
            title: t("constraints.process"),
            dataIndex: "islem",
            key: "islem",
            align: "center",
            width: 220,
            render: (record, row) => {
                return (
                    <div className='flex flex-row gap-3 justify-center'>
                        <Button
                            onClick={() => handleClick(row)}
                            style={{ fontFamily: "sans-serif" }}
                            className='text-white bg-smartopt font-semibold'
                        >
                            {t("constraints.change")}
                        </Button>
                        <Popconfirm
                            title={t("constraints.delete")}
                            description={t("constraints.confirmDelete")}
                            onConfirm={() => {
                                handleDelete(row)
                                message.success(t("constraints.updateSuccess"));
                            }}
                            onCancel={() => console.log("cancel")}
                            okText={t("constraints.yes")}
                            cancelText={t("constraints.no")}
                            okType="primary"
                        >
                            <Button
                                style={{ fontFamily: "sans-serif" }}
                                className='text-white bg-smartopt font-semibold'
                            >
                                {t("constraints.delete")}
                            </Button>
                        </Popconfirm>
                    </div>
                );
            },
        },
    ];


    return (
        <div style={{ maxHeight: '82vh', overflowY: 'auto' }}>
            <MalzemeKoduModalFront
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                modifiedData={modifiedData}
                selectedRow={selectedRow}
                rule={rule}
                setRefreshPage={setRefreshPage}
                refreshPage={refreshPage}
                getColor={getColor}
                frontBodyMaterialType={frontBodyMaterialType}
            />
            <div className="flex p-4 flex-col h-full gap-2">
                <div className='flex w-max bg-smartopt rounded-lg'>
                    <Button className='text-white font-semibold' onClick={() => {
                        setModalOpen(true)
                        setRule("newOrder")
                        axios.get(`${apiUrl}${window.location.pathname === "/simulasyon" ? "/beta" : ""}/getColor/all`, {
                            auth: {
                                username: username,
                                password: password
                            }
                        })
                            .then(res => setGetColor(res.data))
                            .catch(err => console.log(err))

                        axios.get(`${apiUrl}${window.location.pathname === "/simulasyon" ? "/beta" : ""}/getFrontBodyMaterialType/all`, {
                            auth: {
                                username: username,
                                password: password
                            }
                        })
                            .then(res => setFrontBodyMaterialType(res.data))
                            .catch(err => console.log(err))
                    }}>
                        {t("constraints.addFrontBodyMaterialCode")}
                    </Button>
                </div>

                <div className="tableAsma flex h-full overflow-auto w-full">
                    <Table
                        bordered
                        sticky
                        dataSource={modifiedData}
                        columns={columns}
                        scroll={{ x: 1000 }}
                        pagination={{ pageSize: 6 }}
                    />
                </div>
            </div>
        </div>
    )
}

export default MalzemeKoduFront
